<template>
  <String class="string--warm-white" :strLength="this.strLength">
    <WarmWhiteLED :brightness="channelOneBrightness"/>
    <WarmWhiteLED :brightness="channelTwoBrightness"/>
  </String>
</template>

<script>
  import String from './String';
  import WarmWhiteLED from '../Lights/WarmWhite';

  export default {
    name: 'WarmWhiteString',
    components: {
      String,
      WarmWhiteLED
    },
    props: {
      channelOneBrightness: Number,
      channelTwoBrightness: Number,
      strLength: {
        type: Number,
        default: 20
      }
    }
  };
</script>

<style>

</style>
